import { render, staticRenderFns } from "./AddEditTradePrice.vue?vue&type=template&id=d22d1ffa&"
import script from "./AddEditTradePrice.vue?vue&type=script&lang=js&"
export * from "./AddEditTradePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports